import { AbstractPmsApiService } from "./abstract.service";
import { ItemCategory } from "../models";

/**
 * @class ItemCategoryPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<ItemCategory>}
 */
export class ItemCategoryPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/item-category(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {ItemCategory}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new ItemCategory(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<ItemCategory>>}
     */
    get (params = {}, property = null) {
        
        const url = this.url({propertyId: property ? property.id : 0});
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {ItemCategory} category
     * @param {Property} property
     * @returns {Promise.<ItemCategory>}
     */
    create(category, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .post(url, category.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {ItemCategory} category
     * @returns {Promise.<ItemCategory>}
     */
    update(category) {
        
        const url = this.url({
            propertyId: category.property.id,
            id:         category.id
        });
        
        return this.http
                   .put(url, category.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {ItemCategory} category
     * @returns {Promise.<boolean>}
     */
    delete(category) {
        
        const url = this.url({
            propertyId: category.property.id,
            id:         category.id
        });
        
        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/item-category.service.js